export default __webpack_public_path__ + "static/addcard-hero-6fa6f82f7881d33c4af9055d799c278d.webp";